<template>
    <div class="card rounded-xl border !shadow-none" :class="{'border-animation': search && index == 0}">
      <div class="card-body gap-0 p-1.5 xl:p-4">
                <div class="relative rounded-lg overflow-hidden">
           <img class=" cursor-pointer flex-1 m-auto" :src="product.image" alt="product" @click="$emit('getProduct',product.slug)" />
                     <div class="text-sm xl:text-base text-gray-custom-3 absolute bottom-0 w-full bg-gray-100 text-center">{{__('Product Code') + ': ' + (product.sku)}}</div>
           </div>
        <div class="bg-red-custom-2 px-2 xl:px-3 text-white rounded-bl-xl text-sm xl:text-base absolute top-0 right-0" v-if="product.wholesale_price && product.regular_price > product.wholesale_price">{{ discount(product.regular_price,product.wholesale_price) }}%</div>
        <h1 class="font-bold text-xs xl:text-sm my-1 md:my-3 text-gray-custom-3 line-clamp-2 hover:text-blue-600 cursor-pointer" @click="$emit('getProduct',product.slug)">
          {{ product.title }} <span class="text-red-custom-2" v-if="product.group_sale">({{ product.group_sale + ' ' + __('Integer')}})</span>
        </h1>
        <div class="card-actions justify-center items-center mt-auto">
          <ProductQuantity :product="product" @change="change" />
          <div class="flex-grow text-center 2xl:text-end flex flex-col sm:flex-row xl:flex-col items-end">
            <p class="inline-block" v-if="$route.meta.type === 'change'">
              <span class="text-gray-custom-1 font-medium text-xs line-through">{{product.previous_price.toLocaleString()}}</span>
              <Currency size="small" />
            </p>
            <p class="flex flex-col" v-if="product.wholesale_price">
              <span class="text-red-custom-2 font-medium text-sm md:text-base">{{product.wholesale_price.toLocaleString()}} <Currency /></span>
              <span class="text-gray-custom-2 text-sm line-through ml-7" v-if="$route.meta.type != 'change' && product.regular_price > product.wholesale_price">{{ product.regular_price.toLocaleString() }}</span>
            </p>
            <p class="flex flex-col text-info">{{ __('Price is changing.') }}</p>
            <!-- <button class="btn btn-success btn-sm mr-2 hidden lg:block" @click="$emit('getProduct',product.slug)">
              <EyeIcon class="w-5 h-5" />
            </button> -->
          </div>
        </div>
        <!-- <div class="divider my-0 h-auto hidden xl:flex"></div> -->
        <div class="flex flex-col xl:flex-row justify-center items-center">
          <!-- <div class="text-xs text-gray-custom-1">{{__('brand') + ': ' + (product.brand || '---')}}</div> -->
          <div class="text-xs mt-2" v-if="product.payment_method">
            <!-- <span class="text-gray-custom-1">{{__('sale') + ': '}}</span> -->
            <span class="badge px-1 md:px-3 text-xs border-0"
              :class="[product.payment_method === 'cash' ? '!bg-red-custom-1 !text-red-custom-2' : ' !bg-green-custom-2 !text-green-custom-3']">
              {{__(product.payment_method?.capitalize()) + (product.payment_term ? ' - ' + product.payment_term + ' ' + __('Day') : '')}}
            </span>
          </div>
        </div>
      </div>
    </div>
</template>
<script setup>
import Currency from '../../svg/Currency.vue';
import ProductQuantity from './ProductQuantity.vue';
import { discount } from '@/util.js';
const emit = defineEmits(['getProduct','changeQuantity']);
defineProps(['product','grid', 'loading','index','search']);
const change = (product,increase = true) => emit('changeQuantity',product,increase);
</script>